import { render, staticRenderFns } from "./WidgetTickets.vue?vue&type=template&id=65f10c1c&scoped=true&"
import script from "./WidgetTickets.vue?vue&type=script&lang=js&"
export * from "./WidgetTickets.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTickets.vue?vue&type=style&index=0&id=65f10c1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f10c1c",
  null
  
)

export default component.exports